import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderCTA"] */ "/vercel/path0/src/components/layout/header-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroCTA"] */ "/vercel/path0/src/components/sections/hero-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorksCTA"] */ "/vercel/path0/src/components/sections/how-it-works-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorksVideo"] */ "/vercel/path0/src/components/sections/how-it-works-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JewelryCollectionCTA"] */ "/vercel/path0/src/components/sections/jewelry-collection-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoCard"] */ "/vercel/path0/src/components/sections/video-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoShowcaseCTA"] */ "/vercel/path0/src/components/sections/video-showcase-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundGradient"] */ "/vercel/path0/src/components/ui/background-gradient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Compare"] */ "/vercel/path0/src/components/ui/compare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HashNavigator"] */ "/vercel/path0/src/components/ui/hash-navigator.tsx");
